import {
  SENTIDOS,
  TRAZAS,
  ACTUACION_ELEMENTOS_SEÑALIZACION_BALIZAMIENTO_CONTENCION,
  ELEMENTOS_CONTENCION,
  UNIDADES
} from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'
import comunValidacionFormFields from './comunValidacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'elementosContencion',
    familyFragment,
    [TYPES.BARRERA_METALICA, TYPES.BARRERA_HORMIGON, TYPES.PRETIL]
  ),

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'pkFin'
    ]
  },

  {
    label: 'Sentido',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'sentido'
    ],
    meta: {
      options: SENTIDOS
    }
  },

  {
    label: 'Traza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'traza'
    ],
    meta: {
      options: TRAZAS
    }
  },

  {
    label: 'Actuación',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'actuacion'
    ],
    meta: {
      options: ACTUACION_ELEMENTOS_SEÑALIZACION_BALIZAMIENTO_CONTENCION
    }
  },

  {
    label: 'Elementos',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'elementos'
    ],
    meta: {
      options: ELEMENTOS_CONTENCION
    }
  },

  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos despues',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'elementosContencion',
      familyFragment,
      'ejecucion',
      'despuesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const validacion = comunValidacionFormFields('elementosContencion')
